import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OutrasReceitasListarComponent } from './outras-receitas-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: OutrasReceitasListarComponent }
    ])],
    exports: [RouterModule]
})
export class OutrasReceitasListarRoutingModule { }
